import comp from "./RepeatIcon";
export default comp;
